import { Store, SerializedData } from "bernie-core";
import { observable, action } from "mobx";
import { Logger, NOOP_LOGGER } from "bernie-logger";

export class AdvertisingStore extends Store {
  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @observable
  public adsloader: string;
  @observable
  public adsloaderFallback: string;
  @observable
  public includeAdLoader: boolean;
  @observable
  public adsSuppressed: boolean;
  @observable
  public CMPTST: string;
  @observable
  public adSlotIdOverride: string;
  @observable
  public adBlockDetect: string;
  @observable
  public adBlockerEnabled?: boolean;

  private disableFramework: boolean;

  public static DEFAULTS = {
    adsloader: "",
    adsloaderFallback: "",
    includeAdLoader: false,
    adsSuppressed: false,
    disableFramework: false,
    CMPTST: "",
    adSlotIdOverride: "",
    adBlockDetect: "",
  };

  @action
  private suppressAds(scope: string) {
    scope = scope.toUpperCase();

    if (scope === "FRAMEWORK") {
      this.disableFramework = true;
      this.adsSuppressed = true;
      this.includeAdLoader = false;
    } else if (scope === "SPOTS") {
      this.adsSuppressed = true;
    }
  }

  @action
  private overrideTargeting(targetingKey: string) {
    this.CMPTST = targetingKey;
  }

  @action
  private overrideSlotId(slotId: string) {
    this.adSlotIdOverride = slotId;
  }

  @action
  public includeAd() {
    if (!this.disableFramework) {
      this.includeAdLoader = true;
    }
  }

  @action
  public overrideWithQueryParams(queryParams: { [key: string]: string }) {
    if (queryParams.suppressAds) {
      this.suppressAds(queryParams.suppressAds.toUpperCase());
    }

    if (queryParams.adTargetingOverride) {
      this.overrideTargeting(queryParams.adTargetingOverride);
    }

    if (queryParams.adSlotIdOverride) {
      this.overrideSlotId(queryParams.adSlotIdOverride);
    }
  }
}
